import { useContext, createContext } from "react";
import { useLocalization } from "./localization-hooks";

export const defaultLang = "en-us";
export const availableLangList = ["en-us"];

type ContextLocalizationType = ReturnType<typeof useLocalization>;
export const localizationContext =
  createContext<ContextLocalizationType | null>(null);

export function useContextLocalization() {
  const context = useContext(localizationContext);

  if (!context) {
    throw new Error(
      "useContextLocalization must be used within a ContextLocalizationProvider",
    );
  }

  return context;
}

export function ContextLocalizationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const localization = useLocalization();
  const { currentLang } = localization;

  if (!currentLang) {
    return null;
  }

  return (
    <localizationContext.Provider value={localization}>
      {children}
    </localizationContext.Provider>
  );
}
